import graphql from 'babel-plugin-relay/macro';
import {FormikHelpers} from 'formik';
import React from 'react';
import {useMutation} from 'react-relay/hooks';
import {useHistory} from 'react-router';
import ConnectionHandler from 'relay-connection-handler-plus';
import {showEventNotification} from 'src/utils/notifications';

import Form from '../components/Form';
import {FormValues} from '../types';
import {createPageCreateValveManufacturerMutation} from './__generated__/createPageCreateValveManufacturerMutation.graphql';

function CreatePage() {
  const history = useHistory();

  const [commit, isInFlight] = useMutation<createPageCreateValveManufacturerMutation>(
    createValveManufacturerMutation,
  );

  return (
    <Form
      title="Create Valve Manufacturer"
      button="Create Valve Manufacturer"
      onSubmit={handleSubmit}
      isSubmitting={isInFlight}
    />
  );

  function handleSubmit(input: FormValues, formikHelpers: FormikHelpers<FormValues>) {
    commit({
      variables: {input},
      onCompleted: payload => {
        if (
          payload.createValveManufacturer?.errors[0] &&
          payload.createValveManufacturer?.errors[0].fields
        ) {
          payload.createValveManufacturer?.errors[0].fields.forEach(fieldError => {
            formikHelpers.setFieldError(fieldError.fieldName, fieldError.message);
          });
        }

        const entry = payload.createValveManufacturer?.valveManufacturer;

        if (entry) {
          showEventNotification('added', 'Manufacturer', entry.name);
          return history.push('/admin/valve_manufacturers');
        }
      },
      updater: store => {
        const root = store.getRoot();

        const connectionRecords = ConnectionHandler.getConnections(
          root,
          'ValveManufacturersList_valveManufacturers',
        );

        if (!connectionRecords) {
          return;
        }

        const payload = store.getRootField('createValveManufacturer');

        if (!payload) {
          return;
        }

        const newRecord = payload.getLinkedRecord('valveManufacturer');

        if (!newRecord) {
          return;
        }

        connectionRecords.forEach(connectionRecord => {
          const newEdge = ConnectionHandler.createEdge(
            store,
            connectionRecord,
            newRecord,
            'valveManufacturerEdge',
          );

          ConnectionHandler.insertEdgeAfter(connectionRecord, newEdge);
        });
      },
    });
  }
}

const createValveManufacturerMutation = graphql`
  mutation createPageCreateValveManufacturerMutation($input: CreateValveManufacturerInput!) {
    createValveManufacturer(input: $input) {
      valveManufacturer {
        id
        createdAt
        name
      }
      errors {
        code
        fields {
          fieldName
          message
        }
      }
    }
  }
`;

export default CreatePage;
